import classNames from 'classnames';
import type { BlockAnimation } from '../types';
// This is undocumented hook from Next.js. Use with caution!!!!!
// import { useIntersection } from "next/dist/client/use-intersection";
import { getAnimationClassName } from './getAnimationClassName';

export function useAnimatedBlock(animation: BlockAnimation | undefined): [(element: Element | null) => void, string] {
  // TODO: fix animation
  // const [setElement, isVisible] = useIntersection({});
  const [setElement, isVisible] = [() => {}, false];

  if (!animation) return [setElement, ''];

  const animationClassname = getAnimationClassName(animation);
  return [
    setElement,
    classNames(animationClassname, {
      'animated-block-initial': !isVisible,
      'animated-block-visible': isVisible,
    }),
  ];
}
